/**
 * AuthProvider Interface
 * Abstraction for authentication token management
 */

/**
 * Authentication provider interface
 * Allows different authentication strategies (JWT, OAuth, etc.)
 */
export interface AuthProvider {
  /**
   * Get current authentication token
   * Returns null if not authenticated
   */
  getToken(): string | null;

  /**
   * Set authentication token
   */
  setToken(token: string): void;

  /**
   * Clear authentication token
   */
  clearToken(): void;

  /**
   * Check if user is authenticated
   */
  isAuthenticated(): boolean;
}

/**
 * Local storage based authentication provider
 * Uses localStorage to persist JWT tokens
 * Note: Uses 'access_token' key to match TokenManager
 */
export class LocalStorageAuthProvider implements AuthProvider {
  private static readonly TOKEN_KEY = 'access_token';

  public getToken(): string | null {
    return localStorage.getItem(LocalStorageAuthProvider.TOKEN_KEY);
  }

  public setToken(token: string): void {
    localStorage.setItem(LocalStorageAuthProvider.TOKEN_KEY, token);
  }

  public clearToken(): void {
    localStorage.removeItem(LocalStorageAuthProvider.TOKEN_KEY);
  }

  public isAuthenticated(): boolean {
    return this.getToken() !== null;
  }
}
